import React from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import _ from 'underscore';
import $ from 'jquery';

import { merge } from '@bingads-webui-universal/primitive-utilities';
import { HighchartReactWrapper } from '@bingads-webui-react/highchart-react-wrapper';
import { FluctuationTypeKey } from '@bingads-webui-campaign-react/fluctuation-popup';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { getFilteredCampaignTypeFromRawFilter } from '@bingads-webui-campaign/campaign-ui-common';
import { withGlobalFilter } from '@bingads-webui-react/global-filter-context';

import { ChartLabel } from './chart-label';
import { ChartPanel } from './chart-panel';
import { ChartFormatter } from './chart-formatter';
import { FluctuationPanel } from './fluctuation-panel';
import { highchartsStyle, highchartsStyleVNextOverride } from '../style/js/highcharts-style';
import { Defaults } from './constants';
import { ChartDataAdapter } from './chart-data-adapter';
import { instrumentationSchema } from './inline-chart-instr-schema';
import { ImpressionsID, ClicksID, SpentID, ConvID, PartialConvID, VideoMetricColumns } from './chart-metrics-adapter';

const WaterfallFilterTypeCampaignType = 0;

export class InlineChartInternal extends React.PureComponent {
  constructor(props) {
    super(props);


    if (this.props.perfMarker) {
      this.perfMarker = this.props.perfMarker.createChild('Inline_Chart_Init_Load', { isActiveChild: false });
      this.perfMarker.willInit();
    }

    this.initializeInstrumentation();
    this.i18n = this.props.i18n;
    // Register date change handler.
    this.props.options.addDateChangeListener(this.onDateChangeHandler.bind(this));
    this.props.options.resizeChartListener(this.onResizeWindow.bind(this));

    this.campaignType = getFilteredCampaignTypeFromRawFilter(this.props[WaterfallFilterTypeCampaignType]);

    this.chartFormatter = new ChartFormatter();
    this.chartDataAdapter =
      new ChartDataAdapter({
        i18n: this.i18n,
        permissions: this.props.options.pageContext.Permissions,
        gridName: this.props.options.pageContext.CurrentGridName,
        lowestSupportedGranularity: this.props.options.lowestSupportedGranularity,
        campaignType: this.campaignType,
      });
    this.isInitialized = false;
    this.isOuterContainerInitialized = false;
    this.isPendingFetch = false;
    this.inlineChartColumnMerticsEnabled = false;

    if (this.props.serverContext && this.props.serverContext.DynamicPermissions) {
      this.inlineChartColumnMerticsEnabled =
        this.props.serverContext.DynamicPermissions.InlineChartColumnMerticsEnabled;
    }

    this.chartData = {};

    const permissions = this.props.options.pageContext.Permissions || {};
    ({
      dynamic: {
        ColumnConversion: this.IsColumnConversionEnabled,
        PartialConversions: this.IsPartialConversionsEnabled,
      } = {},
    } = permissions);

    this.withoutOpporCheck = permissions.dynamic && permissions.dynamic.FluctuationsWithoutRecCheck;

    this.state = {
      isLoading: true,
      isPopEnabled: false,
      isDataAvailable: false,
      isShowChart: true,
      isShowStartDateLabel: true,
      isShowEndDateLabel: true,
      flucData: [],
      chartMarginRight: 0,
      primaryMetricSelectionId: Defaults.primaryMetricId,
      secondaryMetricSelectionId: Defaults.secondaryMetricId,
      granularitySelectionId: Defaults.graunlarityId,
      // Used to only track moving average status. It may be enabled, but hidden if PoP is ON.
      isMovingAverageEnabled: Defaults.showMovingAverage,
      primaryMetricPercentage: '',
      secondaryMetricPercentage: '',
      chartLabelData: {},
      // Combine highchart data and style as highchart options
      noChartText: this.chartDataAdapter.getNoDataText(),
      dateRange: {},
      formattedHighChartOptions: {},
      fluctuationLoading: false,
    };

    const currentTab = this.props.options.gridCriterionType;
    const currentEntity = this.props.options.entityType;
    const { adGroupId } = (this.props.scope && this.props.scope.values) || {};

    const getMetricFilters = () => {
      const CPSAndInstallMetrics = ['AverageCPS', 'SalesCount', 'Installs', 'CostPerInstall', 'RevenuePerInstall'];
      const ConvValueRulesMetrics = ['AdvertiserReportedRevenueAdjustment', 'ViewThroughConversionsRevenueAdjustment', 'AllConversionAdvertiserReportedRevenueAdjustment'];
      const ConvValueRulesAllowedEntities = ['Account', 'Campaign', 'AdGroup', 'Ad', 'Keyword'];

      const fitlerMetrics = [];
      // only account/Perf, campaign, adgroup, ads and positive keyword can show Conversion Value Rule Metrics
      if (!ConvValueRulesAllowedEntities.includes(currentEntity)) {
        fitlerMetrics.push(...ConvValueRulesMetrics);
      }

      // for Demographics tab , CPA is no longer avaliable in Age and Gender grid
      if (currentTab === 'Age' || currentTab === 'Gender') {
        fitlerMetrics.push(...CPSAndInstallMetrics, 'CPA');
      }
      // for Keyword tab, hide video metrics
      if (currentEntity === 'Keyword') {
        fitlerMetrics.push(...CPSAndInstallMetrics, ...VideoMetricColumns);
      }

      const isCPSEntitiesCondition = ['Campaign', 'AdGroup', 'Account'].includes(currentEntity);
      const CPSProductgroupCondition = currentTab === 'ProductGroup' && !adGroupId;
      if (!(isCPSEntitiesCondition || CPSProductgroupCondition)) {
        fitlerMetrics.push(...CPSAndInstallMetrics);
      }

      const uniqueFilterMetrics = _.uniq(fitlerMetrics);
      if (!_.isEmpty(uniqueFilterMetrics)) {
        return metric => !uniqueFilterMetrics.includes(metric.name);
      }
      return null;
    };

    this.primaryMetricsList =
      this.chartDataAdapter.getPrimaryMetricsList(
        permissions,
        getMetricFilters(),
        this.props.options.customMetricNameList,
        currentEntity
      );

    this.secondaryMetricsList =
      this.chartDataAdapter.getSecondaryMetricsList(
        permissions,
        getMetricFilters(),
        this.props.options.customMetricNameList,
        currentEntity
      );
  }

  componentDidMount() {
    this.canceled = false;
    // get promise for current daterange, preferences
    Promise.all([
      this.props.options.pageState.getPromise('$daterange'),
      this.chartDataAdapter.getPreferencesAndDefaults(
        this.props.options.preference,
        this.props.options.pageContext
      )])
      .spread((dateRange, preferences) => {
        if (!this.canceled) {
          // Check if preference option loaded still available (might change due to pilot)
          const normalizedPreferences = this.normalizeWithAvailable(preferences);
          const selectedGranularityId = this.chartDataAdapter.reevaluateGranularity(
            dateRange,
            normalizedPreferences.granularityId
          );

          this.activities.chartActionActivity.trace(`Inline Chart reevaluated granularity
            preference granularity id  ${normalizedPreferences.granularityId},
            new granularity id ${selectedGranularityId}`, 'InlineChartAction');

          this.isInitialized = true;
          // Update all the state that will be used by next render cycle to update UI.
          // Make sure both daterange and granularity are updated together.
          this.setState((prevState, newProps) =>
            this.updateState(dateRange, newProps, normalizedPreferences, selectedGranularityId));
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.isInitialized || !this.isOuterContainerInitialized) {
      // We need to wait till we read the preference store and daterange
      // before acting on any updates. Keep the initial fetch as pending.
      this.isPendingFetch = true;
      return;
    }

    if (this.perfMarker && !this.perfMarker.isDone && !this.state.isLoading && this.isInitialized) {
      this.perfMarker.done();
    }

    if (prevProps.isShowChart !== this.props.isShowChart) {
      this.toggleChartState(!this.state.isShowChart);
    }

    if (this.chartDataAdapter.isDateRangeChanged(prevProps.dateRange, this.props.dateRange)) {
      // new date range is passed in as props
      // do not directly trigger refresh
      // instead call below handler to let it handle state update and refresh
      // chartDataAdapter.isDateRangeChanged takes care of null or undefined checks
      this.onDateChangeHandler(null, this.props.dateRange);
      return;
    }

    if (_.isUndefined(this.state.granularitySelectionId)) {
      // Skip fetch if granularity is not defined.
      return;
    }

    if (!this.state.isShowChart) {
      // Don't fetch in background if chart is hidden. Only fetch on show chart.
      this.isPendingFetch = true;
      return;
    }
    // As componentDidUpdate is invoked on update to any of the props or state, check
    // for changes that require fetch and conditionally trigger it.
    if (
      this.isPendingFetch ||
      (this.isFilterChanged(prevProps.filter, this.props.filter)) ||
      (this.isCustomFilterChanged(prevProps.customFilter, this.props.customFilter)) ||
      (this.chartDataAdapter.isDateRangeChanged(prevState.dateRange, this.state.dateRange)) ||
      (prevState.isPopEnabled !== this.state.isPopEnabled) ||
      // If this.props.gridDataSource is not undefined
      // Don't fetch data when granularity or movingAverage changes
      (!this.props.gridDataSource &&
        prevState.granularitySelectionId !== this.state.granularitySelectionId) ||
      (!this.props.gridDataSource &&
        prevState.isMovingAverageEnabled !== this.state.isMovingAverageEnabled)) {
      // Reset pending fetch.
      this.isPendingFetch = false;

      if (this.perfMarker) {
        this.perfMarker.willFetchData();
      }

      // Fetch performance time series
      this.fetchPerformanceAndFluctuation(
        this.state.dateRange,
        this.state.granularitySelectionId,
        // If this.props.gridDataSource is not undefined
        // Use grid data when we didn't show / hide inline chart
        this.props.gridDataSource && prevState.isShowChart === this.state.isShowChart
      );
      this.activities.chartActionActivity.trace('State Updated. Render starts', 'InlineChartAction');
    }
  }

  componentWillUnmount() {
    this.canceled = true;
  }

  onDateChangeHandler = (e, newDateRange) => {
    if (!this.isInitialized) {
      // No data to compare yet. Wait till initialization finishes.
      return;
    }

    if (this.props.perfMarker) {
      this.actionPerfMarker = this.props.perfMarker.createChild('Inline_Chart_Action', { isActiveChild: false });
      this.actionPerfMarker.willInit();
    }

    this.activities.chartActionActivity.trace(`Inline Chart Date Change received
    ${JSON.stringify(newDateRange)}`, 'InlineChartAction');

    // Daterange object received through notification is different
    // Eg. title field string can differ. So we only compare, start,end,
    // compared start, end fields to determine time range change and proccess further.
    if (!this.chartDataAdapter.isDateRangeChanged(newDateRange, this.state.dateRange)) {
      this.activities.chartActionActivity.trace(`Inline Chart Date Change no change
      ${JSON.stringify(this.state.dateRange)}`, 'InlineChartAction');
      return;
    }

    // Update granularity selection and available granularity list
    const selectedGranularityId =
      this.chartDataAdapter.reevaluateGranularity(newDateRange, this.state.granularitySelectionId);

    this.activities.chartActionActivity.trace(`Inline Chart reevaluated granularity
     old granularity id  ${this.state.granularitySelectionId},
     new granularity id ${selectedGranularityId}`, 'InlineChartAction');

    const newState = {
      granularitySelectionId: selectedGranularityId,
      dateRange: newDateRange,
      isPopEnabled: !!newDateRange.compared,
      chartLabelData: {},
    };

    if (_.isUndefined(selectedGranularityId)) {
      newState.isDataAvailable = false;
    }

    // Update all the state that will be used by next render cycle to update UI.
    this.setState(newState);
  };

  onResizeWindow = (newWidth) => {
    if (!newWidth || (this.chart && newWidth === this.chart.chartWidth)) {
      return;
    }

    this.isOuterContainerInitialized = true;

    let width = newWidth;
    const inlineChartContainer = $('.inline-chart-container');

    if (inlineChartContainer) {
      width -= (parseFloat(inlineChartContainer.css('paddingLeft')) +
        parseFloat(inlineChartContainer.css('paddingRight')));
    }

    this.props.options.resizeEventHandler();

    this.resizeChart(width);
  };

  onPrimaryMetricChange = (selection) => {
    if (selection.id === this.state.primaryMetricSelectionId) {
      // No op if selection is same metric as currently set.
      return;
    }

    if (this.props.perfMarker) {
      this.actionPerfMarker = this.props.perfMarker.createChild('Inline_Chart_Action', { isActiveChild: false });
      this.actionPerfMarker.willInit();
    }

    // Save to preference store
    this.saveToPrefrenceStore('primaryMetric', selection.id);

    if (this.inlineChartColumnMerticsEnabled) {
      this.setState({
        primaryMetricSelectionId: selection.id,
      }, () => {
        this.fetchPerformanceData(
          this.state.dateRange,
          this.state.granularitySelectionId
        );
      });
    } else {
      // Compute the new chart options
      const formattedOptions = this.getFormattedChartOptions(
        selection.id,
        this.state.secondaryMetricSelectionId
      );

      this.setState({
        primaryMetricSelectionId: selection.id,
        formattedHighChartOptions: formattedOptions,
      });
    }

    this.activities.chartActionActivity.trace(
      `Inline Chart primary metric changed: ${selection.id}`,
      'InlineChartAction'
    );
  };

  onSecondaryMetricChange = (selection) => {
    if (selection.id === this.state.secondaryMetricSelectionId) {
      // No op if selection is same metric as currently set.
      return;
    }

    if (this.props.perfMarker) {
      this.actionPerfMarker = this.props.perfMarker.createChild('Inline_Chart_Action', { isActiveChild: false });
      this.actionPerfMarker.willInit();
    }

    // Save to preference store
    this.saveToPrefrenceStore('secondaryMetric', selection.id);

    if (this.inlineChartColumnMerticsEnabled) {
      this.setState({
        secondaryMetricSelectionId: selection.id,
      }, () => {
        this.fetchPerformanceData(
          this.state.dateRange,
          this.state.granularitySelectionId
        );
      });
    } else {
      // Compute the new chart options
      const formattedHighChartOptions = this.getFormattedChartOptions(
        this.state.primaryMetricSelectionId,
        selection.id
      );

      this.setState({
        secondaryMetricSelectionId: selection.id,
        formattedHighChartOptions,
      });
    }

    this.activities.chartActionActivity.trace(
      `Inline Chart secondary metric changed: ${selection.id}`,
      'InlineChartAction'
    );
  };

  onGranularityChange = (selection) => {
    if (selection.id === this.state.granularitySelectionId) {
      // No op if selection is same granularity as currently set.
      return;
    }

    if (this.props.perfMarker) {
      this.actionPerfMarker = this.props.perfMarker.createChild('Inline_Chart_Action', { isActiveChild: false });
      this.actionPerfMarker.willInit();
    }

    // Save to preference store
    const granularityEnum = this.chartDataAdapter.getGranularityEnum(selection.id);
    this.saveToPrefrenceStore('granularity', granularityEnum);

    if (this.props.gridDataSource) {
      this.setState({
        granularitySelectionId: selection.id,
        chartLabelData: {},
      }, () => {
        this.fetchPerformanceAndFluctuation(
          this.state.dateRange,
          this.state.granularitySelectionId
        );
      });
    } else {
      this.setState({
        granularitySelectionId: selection.id,
        chartLabelData: {},
      });
    }

    this.activities.chartActionActivity.trace(
      `Inline Chart granularity changed: ${selection.id}`,
      'InlineChartAction'
    );
  };

  onMovingAverageChange = (event) => {
    if (this.props.perfMarker) {
      this.actionPerfMarker = this.props.perfMarker.createChild('Inline_Chart_Action', { isActiveChild: false });
      this.actionPerfMarker.willInit();
    }

    // Save to preference store
    this.saveToPrefrenceStore('showMovingAverage', event.target.checked);

    // Compute the new chart options
    const formattedHighChartOptions = this.getFormattedChartOptions(
      this.state.primaryMetricSelectionId,
      this.state.secondaryMetricSelectionId
    );

    if (this.props.gridDataSource) {
      this.setState({
        isMovingAverageEnabled: event.target.checked,
        formattedHighChartOptions,
      }, () => {
        this.fetchPerformanceAndFluctuation(
          this.state.dateRange,
          this.state.granularitySelectionId
        );
      });
    } else {
      this.setState({
        isMovingAverageEnabled: event.target.checked,
        formattedHighChartOptions,
      });
    }

    this.activities.chartActionActivity.trace(
      `Inline Chart moving average changed: ${event.target.checked}`,
      'InlineChartAction'
    );
  };

  onToggleLabel = ({ isShowStartDateLabel, isShowEndDateLabel }) => {
    this.setState({
      isShowStartDateLabel,
      isShowEndDateLabel,
    });
  };

  onChartRendered = (chart) => {
    this.activities.chartActionActivity.trace('Inline Chart chart render finished', 'InlineChartAction');
    this.chart = chart;
    this.resizeChart();

    if (this.props.options.isFluctuationsEnabled &&
      !(this.isFilterActive()) &&
      this.state.granularitySelectionId === 1 &&
      this.state.isDataAvailable &&
      this.fluctuationProm) {
      this.fluctuationProm.then((result) => {
        if (this.chart &&
          this.chart.series) {
          this.setState({
            chartMarginRight: chart.marginRight,
          });
          if (this.panelRef) {
            this.panelRef.onChartUpdated(chart);
          }
          this.activities.chartActionActivity.trace(`Chart shifted: ${this.state.chartMarginRight}`, 'InlineChartAction');
        }

        this.activities.chartActionActivity.trace(`Fluctuation data received ${result.length}`, 'InlineChartAction');
        this.activities.chartActionActivity.trace(`Inline Chart Shown with Fluctuations Date: ${JSON.stringify(_.extend(this.state.chartLabelData, {
          entity: this.props.options.entityType,
          startDate: this.chartFormatter.getRawDate(this.state.dateRange.start, this.i18n),
          endDate: this.chartFormatter.getRawDate(this.state.dateRange.end, this.i18n),
        }))}`, 'FluctuationAction');
      });
    } else {
      this.isFlucRenderNotRequired = true;
      if (!(this.state.isShowStartDateLabel) ||
        !(this.state.isShowEndDateLabel)) {
        this.setState({
          flucData: [],
          isShowStartDateLabel: true,
          isShowEndDateLabel: true,
        });
      }
    }

    if (this.actionPerfMarker && !this.actionPerfMarker.isDone) {
      this.actionPerfMarker.done();
    }
  };

  getFormattedChartOptions = (primaryMetricId, secondaryMetricId) => {
    const { seriesColors } = this.props.options;
    const primaryMetric =
      this.chartDataAdapter.getMetricItem(primaryMetricId);
    const secondaryMetric =
      this.chartDataAdapter.getMetricItem(secondaryMetricId);

    const highChartData = this.chartFormatter.getFormattedHighChart(
      this.chartDataAdapter,
      {
        primaryMetric,
        secondaryMetric,
        granularityId: this.state.granularitySelectionId,
        isMovingAverageOn: this.state.isMovingAverageEnabled && this.isMovingAverageVisible(),
        chartWidth: this.state.chartWidth,
        seriesColors,
      },
      this.chartData
    );

    merge(highchartsStyle, highchartsStyleVNextOverride);

    return merge(highChartData, highchartsStyle);
  };

  getChartElement() {
    let noDataOrLoading = this.state.isLoading ? (
      <div className="spinner">
        <div className="spinner-icon" />
      </div>
    ) : null;

    /* eslint-disable react/no-danger */
    if (_.isUndefined(this.state.granularitySelectionId) ||
      (!this.state.isDataAvailable && !this.state.isLoading)) {
      noDataOrLoading = (
        <div className="chart-no-data-container">
          <span
            className="chart-no-data-label"
            dangerouslySetInnerHTML={
              {
                __html: this.state.noChartText,
              }
            }
          />
        </div>);
    }

    this.chartLabelRef = React.createRef();
    const chartLabelComponent = (<ChartLabel
      isPopEnabled={this.state.isPopEnabled}
      chartLabelData={this.state.chartLabelData}
      isShowStartDateLabel={this.state.isShowStartDateLabel}
      isShowEndDateLabel={this.state.isShowEndDateLabel}
      ref={this.chartLabelRef}
    />);

    const chart = this.state.isDataAvailable && !this.state.isLoading ? (
      <div>
        <HighchartReactWrapper
          options={this.state.formattedHighChartOptions}
          onChartRenderedCallback={this.onChartRendered}
        />
        {chartLabelComponent}
      </div>)
      : (
        <div>
          {noDataOrLoading}
        </div>);

    return chart;
  }

  getFluctuationMetric = (flucType) => {
    switch (flucType) {
      case FluctuationTypeKey.Impression:
        return ImpressionsID;
      case FluctuationTypeKey.Click:
        return ClicksID;
      case FluctuationTypeKey.Spend:
        return SpentID;
      case FluctuationTypeKey.Conversion:
        return this.IsColumnConversionEnabled && this.IsPartialConversionsEnabled ?
          PartialConvID : ConvID;
      default:
        this.activities.chartActionActivity
          .error(
            `Invalid Fluctuation Type: ${flucType}`,
            'FluctuationError'
          );
        return null;
    }
  };

  setFluctuationFlag(fluxMetrics) {
    _.each(this.primaryMetricsList, (metric) => {
      /* eslint-disable no-param-reassign */
      // fix the bug drop down did not show the bulb icon
      metric.isFluctuation = metric.isFluctuation || _.contains(fluxMetrics, metric.id);
    });
    _.each(this.secondaryMetricsList, (metric) => {
      /* eslint-disable no-param-reassign */
      metric.isFluctuation = metric.isFluctuation || _.contains(fluxMetrics, metric.id);
    });
  }

  getMetricsName() {
    const { primaryMetricSelectionId, secondaryMetricSelectionId } = this.state;
    const metrics = this.chartDataAdapter.getMetricsQuery(
      primaryMetricSelectionId,
      secondaryMetricSelectionId
    );
    return metrics;
  }

  resizeChart(width) {
    if (width && this.chart && this.chart.options) {
      this.chart.setSize(width, null, false);
    }

    // always update state after chart is resized
    // so fluctuation panel can update itself based on new chart size
    if ((width > 0) &&
      width !== this.state.chartWidth) {
      this.setState({
        chartWidth: width,
      });
    }
  }

  initializeInstrumentation = () => {
    this.props.options.instrumentation.addScenario(instrumentationSchema);

    const inlineChartScenario = this.props.options.instrumentation.inlineChart.create();
    this.activities = {
      filterActivity: inlineChartScenario.inlineChartFilter.create(),
      chartActionActivity: inlineChartScenario.inlineChartAction.create(),
      chartErrorActivity: inlineChartScenario.inlineChartError.create(),
    };
  };

  toggleChartState(showChartState) {
    // Save to preference store
    this.saveToPrefrenceStore('showChart', showChartState);

    this.setState({
      isShowChart: showChartState,
    });
    this.activities.chartActionActivity.trace(`Inline Chart toggle show chart: ${showChartState}`, 'InlineChartAction');

    this.canceled = !showChartState;
  }

  updateState(period, props, preferences, granularityId) {
    let primaryMetricSelectionId;
    if (_.isNumber(props.options.defaultPrimaryMetric)) {
      primaryMetricSelectionId = props.options.defaultPrimaryMetric;
    } else if (_.isNumber(preferences.primaryMetricId)) {
      primaryMetricSelectionId = preferences.primaryMetricId;
    }
    return {
      isShowChart: props.isShowChart && preferences.showChart,
      isMovingAverageEnabled: preferences.showMovingAverage,
      primaryMetricSelectionId,
      secondaryMetricSelectionId: preferences.secondaryMetricId,
      granularitySelectionId: granularityId,
      dateRange: period,
      isPopEnabled: !!period.compared,
    };
  }

  // Normalize preference and default back if certain preference config is no longer available
  normalizeWithAvailable(preferences) {
    const normalizedPreferences = preferences;

    // Check and update primary metric selection
    if (!_.find(this.primaryMetricsList, { id: preferences.primaryMetricId })) {
      normalizedPreferences.primaryMetricId = Defaults.primaryMetricId;
      this.saveToPrefrenceStore('primaryMetric', normalizedPreferences.primaryMetricId);
    }

    // Check and update secondary metric selection
    if (!_.find(this.secondaryMetricsList, { id: preferences.secondaryMetricId })) {
      normalizedPreferences.secondaryMetricId = Defaults.secondaryMetricId;
      this.saveToPrefrenceStore('secondaryMetric', normalizedPreferences.secondaryMetricId);
    }

    if (this.props.options.disableMovingAverage) {
      preferences.showMovingAverage = false;
    }

    return normalizedPreferences;
  }

  saveToPrefrenceStore(suffix, value) {
    const prefObj = {};
    prefObj[`${this.props.options.pageContext.CurrentTabId}-${suffix}`] =
      value;
    this.props.options.preference.setInlineChartInfo(prefObj);
  }

  isMovingAverageVisible(
    granularityId = this.state.granularitySelectionId,
    popEnabled = this.state.isPopEnabled
  ) {
    if (this.props.options.disableMovingAverage) {
      return false;
    }
    return (!popEnabled) &&
      (granularityId === Defaults.graunlarityId);
  }

  isFilterActive() {
    const filterString = this.props.filter && this.props.filter.odataV4 ?
      this.props.filter.odataV4({ ignoreCase: false }) : '';
    return (!!filterString);
  }

  isFilterChanged(oldFilter, newFilter) {
    const oldFilterString = oldFilter && oldFilter.odataV4 ?
      oldFilter.odataV4({ ignoreCase: false }) : '';
    const newFilterString = newFilter && newFilter.odataV4 ?
      newFilter.odataV4({ ignoreCase: false }) : '';

    const result = oldFilterString !== newFilterString;
    return result;
  }

  isCustomFilterChanged(oldFilter, newFilter) {
    if (!oldFilter && !newFilter) {
      return false;
    }

    return !_.isEqual(oldFilter, newFilter);
  }

  proceedFluctuation() {
    // Allow fluctuations only for Account and Campaign levels.
    // At campaign level, restrict to pilot users only.
    return (this.props.options.pageContext.CurrentCampaign &&
      !this.props.options.pageContext.CurrentAdGroup) ||
      (!this.props.options.pageContext.CurrentCampaign &&
        !this.props.options.pageContext.CurrentAdGroup);
  }

  updateFlucData(data) {
    this.setState({
      flucData: data,
    });
  }

  updateLoadingStatus(loading) {
    this.setState({
      fluctuationLoading: loading,
    });
  }

  fetchFluctuation(dateRange, granularityId) {
    if (this.props.options.isFluctuationsEnabled) {
      this.activities.chartActionActivity.trace(
        `Fluctuation pilot enabled:
          user type ${this.props.options.pageContext.CurrentUser.IsInternal ? 'internal' : 'external'}`,
        'InlineChartAction'
      );
    }

    if (!this.proceedFluctuation()) {
      return;
    }

    const isFilterActive = this.isFilterActive();
    this.activities.chartActionActivity.trace(
      `InlineChart filter: ${isFilterActive}`,
      'InlineChartAction'
    );

    // Fetch fluctuations only if supported and granularity is 'Day'.
    // surfacingChannelId 0:default, 1:campaign, 2:adgroup, 3:keyword, 4:ad, 5:campaign_grid_overall
    if (granularityId === Defaults.graunlarityId && !isFilterActive) {
      if (this.props.options.isFluctuationsEnabled) {
        const FlucService = this.props.options.fluctuationService;
        const flucServiceIns = new FlucService({
          token: this.props.options.token,
          options: {
            userId: this.props.options.pageContext.CurrentUser.Id,
            customerId: this.props.options.pageContext.CurrentCustomer.Id,
            accountId: this.props.options.pageContext.CurrentAccount.Id,
            campaignId: this.props.options.pageContext.CurrentCampaign &&
              this.props.options.pageContext.CurrentCampaign.Id,
            granularity: Defaults.granularity,
            startDate: this.formatDateString(dateRange.start),
            endDate: this.formatDateString(dateRange.end),
            surfacingChannelId: this.props.options.entityType === 'Campaign' ? 1 : 0,
            isFluctuationsExperiementEnabled: this.props.options.isFluctuationsExperiementEnabled,
          },
        });

        this.logSummary();
        this.fluctuationProm = flucServiceIns.findAll({
          withoutOpporCheck: this.withoutOpporCheck,
        });
        this.fluctuationProm.then((result) => {
          this.setState({
            flucData: result,
          });
          this.activities.chartActionActivity.trace('Fluctuation Request Finished', 'InlineChartFetch');
        }, (errorResult) => {
          this.activities.chartErrorActivity.trace(
            `Fluctuation Request Failed ${JSON.stringify(errorResult)}`,
            'InlineChartFetch'
          );
          this.setState({
            flucData: [],
          });
        });
      }
    }
  }

  fetchPerformanceAndFluctuation(dateRange, granularityId, useGridData) {
    this.fetchPerformanceData(dateRange, granularityId, useGridData).then(() => {
      if (this.perfMarker) {
        this.perfMarker.willRender();
      }

      if (this.props.onFetchPerfData) {
        this.props.onFetchPerfData();
      }
    });
    this.fetchFluctuation(dateRange, granularityId);
  }

  fetchPerformanceData = (dateRange, granularityId, useGridData) => {
    const loading = () => {
      this.setState({
        isLoading: true,
        isDataAvailable: false,
      });
    };

    this.activities.chartActionActivity.trace('Inline Chart Request Started', 'InlineChartFetch');

    const context = {
      filter: this.props.filter,
      period: dateRange,
      granularity: this.chartDataAdapter.getGranularityEnum(granularityId),
      // Moving average needs to be got only if Pop is not shown and granularity is 'day'
      isMovingAverageOn:
        this.isMovingAverageVisible(
          granularityId,
          this.state.popEnabled
        ) && this.state.isMovingAverageEnabled,
      refreshGridData: false,
      currentEntity: this.props.options.entityType,
      metric: this.getMetricsName(),
    };

    // Filter service, filter object includes circular reference causing JSON  stringify to break.
    // Hence storing only filter query string in the log.
    const logContext = {
      filterQuery: context.filter ? context.filter.query : '',
      period: context.period,
      granularity: context.granularity,
      movingAverage: context.isMovingAverageOn,
      entity: context.currentEntity,
      campaignId: this.props.options.pageContext.CurrentCampaign &&
        this.props.options.pageContext.CurrentCampaign.Id,
      metric1: this.state.primaryMetricSelectionId,
      metric2: this.state.secondaryMetricSelectionId,
      isInternal: this.props.options.pageContext.CurrentUser.IsInternal,
    };
    this.activities.chartActionActivity.trace(`Fetch Performance Data: ${JSON.stringify(logContext)}`, 'InlineChartAction');

    if (this.actionPerfMarker) {
      this.actionPerfMarker.willFetchData();
    }

    return new Promise((resolve) => {
      const successCallback = (result) => {
        if (this.actionPerfMarker) {
          this.actionPerfMarker.willRender();
        }

        if (!this.canceled) {
          this.activities.chartActionActivity.trace('Inline Chart Request Finished', 'InlineChartFetch');
          const data = this.chartDataAdapter.prepareData(result);

          if (!_.every(data, this.chartDataAdapter.isPrimaryDataAvailable)) {
            // No preformance time series data
            this.setState({
              isLoading: false,
              isDataAvailable: false,
            });
            resolve();
            return;
          }

          // Cache the chart raw data.
          this.chartData = data;

          // Align chart series.
          if (_.every(data, this.chartDataAdapter.isComparisonDataAvailable)) {
            this.chartDataAdapter.alignDataForComparison(
              data,
              this.chartDataAdapter.getGranularityEnum(granularityId)
            );
          }

          // Update chart label based on chart data and current granularity
          const chartLabel =
            this.chartDataAdapter.getChartLabel(
              data,
              granularityId
            );

          const formattedHighChartOptions = this.getFormattedChartOptions(
            this.state.primaryMetricSelectionId,
            this.state.secondaryMetricSelectionId
          );

          this.setState({
            formattedHighChartOptions,
            isLoading: false,
            isDataAvailable: true,
            chartLabelData: chartLabel,
          });
          resolve();
        }
      };
      const errorCallback = (errorResult) => {
        this.activities.chartErrorActivity.trace(
          `PerformanceTimeSeries Request Failed ${JSON.stringify(errorResult)}`,
          'InlineChartFetch'
        );
        this.setState({
          isLoading: false,
          isDataAvailable: false,
        });
      };
      if (useGridData &&
        typeof this.props.gridDataSource.onLoading === 'function' &&
        typeof this.props.gridDataSource.getChartData === 'function'
      ) {
        this.props.gridDataSource.onLoading(loading);
        this.props.gridDataSource.getChartData(successCallback, errorCallback);
      } else {
        loading();
        this.props.dataSource.findAll(context)
          .then((result) => {
            if (this.props.gridDataSource) {
              this.props.gridDataSource.updateChartData(result);
            }
            return result;
          })
          .then(successCallback, errorCallback);
      }
    });
  };

  formatDateString(dateStr) {
    const leftPadding = s => ((s.length === 1) ? `0${s}` : s);
    const dt = new Date(Date.parse(dateStr));
    const year = `${dt.getFullYear()}`;
    const month = `${dt.getMonth() + 1}`;
    const day = `${dt.getDate()}`;

    return `${year}-${leftPadding(month)}-${leftPadding(day)}`;
  }

  dismissFluc = ({ date, fluctuation }) => {
    const flucData = this.state.flucData.map((item) => {
      const flucItem = item;
      if (flucItem.Date === date) {
        flucItem.FluctuationsPerDate = _.without(
          flucItem.FluctuationsPerDate,
          _.findWhere(flucItem.FluctuationsPerDate, {
            UniqueId: fluctuation.UniqueId,
          })
        );
      }
      return flucItem;
    });

    this.setState({
      flucData,
    });
  };

  logSummary = () => {
    const logContext = {
      entity: this.props.options.entityType,
      campaignId: this.props.options.pageContext.CurrentCampaign &&
        this.props.options.pageContext.CurrentCampaign.Id,
      metric1: this.state.primaryMetricSelectionId,
      metric2: this.state.secondaryMetricSelectionId,
      metricRecommend: this.state.recommendMetricSelectionId,
      isInternal: this.props.options.pageContext.CurrentUser.IsInternal,
    };

    this.activities.chartActionActivity.trace('Fluctuation Request Started', 'InlineChartFetch');
    this.activities.chartActionActivity.trace(`Chart Summary: ${JSON.stringify(logContext)}`, 'InlineChartAction');
  };

  generateFlucData = () => (this.state.flucData ? this.state.flucData.map((item) => {
    const timeWithoutTimezone = item.Date.substring(0, 19);
    const availableFlucMetrics = [];
    let FluctuationsPerDate = [];
    let withoutOpporCheck = false;
    if (item.FluctuationsPerDate) {
      _.each(item.FluctuationsPerDate, (flucItem) => {
        availableFlucMetrics.push(this.getFluctuationMetric(flucItem.FluctuationType));
      });
      ({ FluctuationsPerDate } = item);
    } else if (item.FluctuationList) {
      FluctuationsPerDate = _.map(item.FluctuationList, (flucItem) => {
        availableFlucMetrics.push(this.getFluctuationMetric(flucItem.FluctuationType));
        return {
          FluctuationType: flucItem.FluctuationType,
          UniqueId: flucItem.FluctuationId,
          RootCauses: _.map(flucItem.RootCauses, cause => ({ Message: { MessageId: cause } })),
        };
      });
      withoutOpporCheck = true;
    }

    FluctuationsPerDate = FluctuationsPerDate.filter((fluc) => {
      const flucMetricId = this.getFluctuationMetric(fluc.FluctuationType);
      return flucMetricId === this.state.primaryMetricSelectionId ||
        flucMetricId === this.state.secondaryMetricSelectionId ||
        flucMetricId === this.state.recommendMetricSelectionId;
    });

    this.setFluctuationFlag(availableFlucMetrics);
    return {
      Date: item.Date,
      formattedDate: this.chartDataAdapter.formatDate(
        timeWithoutTimezone,
        this.state.granularitySelectionId
      ),
      FluctuationsPerDate,
      withoutOpporCheck,
    };
  }) : null);

  render() {
    const { options } = this.props;
    const granularityList = this.chartDataAdapter.getGranularitiesList();
    const primarySelection =
      this.chartDataAdapter.getMetricItem(this.state.primaryMetricSelectionId);
    const secondarySelection =
      this.chartDataAdapter.getMetricItem(this.state.secondaryMetricSelectionId);
    const granularitySelection =
      this.chartDataAdapter.getGranularitySelection(this.state.granularitySelectionId);

    const chart = this.getChartElement();

    const granularityOptions = {
      granularityList,
      selectedItem: granularitySelection,
      selectionChangeCallback: this.onGranularityChange,
    };

    const flucPanelEnabled = this.props.options.isFluctuationsEnabled &&
      !(this.isFilterActive()) &&
      this.state.granularitySelectionId === 1 &&
      this.state.isDataAvailable;

    this.activities.chartActionActivity.trace('Chart Render finishes', 'InlineChartAction');
    this.activities.chartActionActivity.trace(`Chart Width: ${this.state.chartWidth}`, 'InlineChartAction');

    this.panelRef = React.createRef();

    const primaryMetricOptions = {
      metricsList: this.primaryMetricsList,
      selectedItem: primarySelection,
      percentage: this.state.primaryMetricPercentage,
      selectionChangeCallback: this.onPrimaryMetricChange,
    };

    const secondaryMetricOptions = {
      metricsList: this.secondaryMetricsList,
      selectedItem: secondarySelection,
      percentage: this.state.secondaryMetricPercentage,
      selectionChangeCallback: this.onSecondaryMetricChange,
    };

    return this.state.isShowChart ? (
      <UiBlocker
        blocking={this.state.fluctuationLoading}
        loadingText={this.i18n.getString('loadingtext')}
        classes={{
          blockUiContainer: 'blocker-global',
          blockerIndicator: 'blocker-indicator',
        }}
      >
        <div className="inline-chart-container">
          {!this.props.options.hideChartPanel && <ChartPanel
            i18n={this.i18n}
            chartTitle={this.chartDataAdapter.getChartTitle(options.pageState)}
            isPopEnabled={this.state.isPopEnabled}
            isMovingAverage={this.state.isMovingAverageEnabled}
            isMovingAverageVisible={this.isMovingAverageVisible()}
            primaryMetric={primaryMetricOptions}
            secondaryMetric={secondaryMetricOptions}
            granularity={granularityOptions}
            movingAverageChangeCallback={this.onMovingAverageChange}
          />}
          <div className="chart-container">
            {chart}
            {flucPanelEnabled ?
              <FluctuationPanel
                ref={(r) => { this.panelRef = r; }}
                fluctuations={this.generateFlucData()}
                updateFlucData={(data) => { this.updateFlucData(data); }}
                updateLoadingStatus={loading => this.updateLoadingStatus(loading)}
                chart={this.chart}
                primaryMetricId={this.state.primaryMetricSelectionId}
                secondaryMetricId={this.state.secondaryMetricSelectionId}
                onPrimaryMetricChange={this.onPrimaryMetricChange}
                chartLabelRef={this.chartLabelRef}
                chartLabelStatus={{
                  isShowStartDateLabel: this.state.isShowStartDateLabel,
                  isShowEndDateLabel: this.state.isShowEndDateLabel,
                }}
                onFlucDismiss={this.dismissFluc}
                onChartLabelToggle={this.onToggleLabel}
                dateRange={{
                  startDate: this.state.dateRange.start,
                  endDate: this.state.dateRange.end,
                }}
                deps={{
                  i18n: this.props.i18n,
                  context: this.props.options.pageContext,
                  instrumentation: this.props.options.instrumentation,
                  token: this.props.options.token,
                  imagePath: this.props.options.imagePath,
                }}
              /> : null}
          </div >
        </div >
      </UiBlocker>
    ) : null;
  }
}

InlineChartInternal.propTypes = {
  /** Is show chart toggle button set */
  isShowChart: PropTypes.bool.isRequired,
  /** i18n */
  i18n: PropTypes.shape({
    getString: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,

  /** Callback to fire when inline chart call is fetched */
  onFetchPerfData: PropTypes.func,
  /** Filter Object */
  filter: PropTypes.shape({
    odataV4: PropTypes.func,
  }),
  /** Data source manager */
  dataSource: PropTypes.shape({
    findAll: PropTypes.func,
  }).isRequired,
  /** Inline chart options */
  options: PropTypes.shape({
    entityType: PropTypes.string,
    isFluctuationsEnabled: PropTypes.bool,
    isFluctuationsExperiementEnabled: PropTypes.bool,
    hideChartPanel: PropTypes.bool,
    defaultPrimaryMetric: PropTypes.number,
    token: PropTypes.string,
    path: PropTypes.string,
    imagePath: PropTypes.string,
    instrumentation: PropTypes.shape({
      addScenario: PropTypes.func,
      inlineChart: PropTypes.shape({
        create: PropTypes.func,
      }),
      fluctuation: PropTypes.shape({
        create: PropTypes.func,
      }),
    }),
    pageContext: PropTypes.shape({
      CurrentCustomer: PropTypes.shape({
        Id: PropTypes.number,
      }),
      CurrentCampaign: PropTypes.shape({
        Id: PropTypes.number,
      }),
      CurrentAdGroup: PropTypes.shape({
        Id: PropTypes.number,
      }),
      CurrentAccount: PropTypes.shape({
        Id: PropTypes.number,
      }),
      CurrentUser: PropTypes.shape({
        Id: PropTypes.number,
        IsInternal: PropTypes.bool,
      }),
      CurrentTabId: PropTypes.string,
      CurrentGridName: PropTypes.string,
      Permissions: PropTypes.shape({
        IsViewThroughConversionEnabled: PropTypes.bool,
        dynamic: PropTypes.shape({
          FluctuationsWithoutRecCheck: PropTypes.bool,
        }),
      }).isRequired,
    }),
    /** Preference store options */
    preference: PropTypes.shape({
      setInlineChartInfo: PropTypes.func,
      getInlineChartInfo: PropTypes.func,
    }),
    /** Page State */
    pageState: PropTypes.shape({
      getPromise: PropTypes.func,
      get: PropTypes.func,
    }),
    /** Fluctuation fetch service */
    fluctuationService: PropTypes.func,
    /** Date picker change handler */
    addDateChangeListener: PropTypes.func,
    /** Resize window change listener to set highchart container width */
    resizeChartListener: PropTypes.func,
    resizeEventHandler: PropTypes.func,
    /**
     * Theme colors, can be null
     */
    seriesColors: PropTypes.shape({
      primary: PropTypes.shape({
        original: PropTypes.string,
        comparative: PropTypes.string,
      }),
      secondary: PropTypes.shape({
        original: PropTypes.string,
        comparative: PropTypes.string,
      }),
    }),
    disableMovingAverage: PropTypes.bool,
    lowestSupportedGranularity: PropTypes.string,
    gridCriterionType: PropTypes.string,
    customMetricNameList: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  dateRange: PropTypes.shape({}),
  perfMarker: perfMarkerPropTypes,
  serverContext: PropTypes.shape({
    DynamicPermissions: PropTypes.shape({
      InlineChartColumnMerticsEnabled: PropTypes.bool,
      CampaignsCombineGridAndChartOdataCallEnabled: PropTypes.bool,
    }),
  }),
  gridDataSource: PropTypes.shape({
    onLoading: PropTypes.func.isRequired,
    getChartData: PropTypes.func.isRequired,
    updateChartData: PropTypes.func.isRequired,
  }),
  customFilter: PropTypes.shape({}),
  scope: PropTypes.shape({
    values: PropTypes.shape({
      adGroupId: PropTypes.number,
    }),
  }),
};

InlineChartInternal.defaultProps = {
  filter: null,
  onFetchPerfData: () => {
    _.noop();
  },
  dateRange: null,
  perfMarker: null,
  serverContext: null,
  gridDataSource: null,
  customFilter: null,
  scope: {
    values: {
      adGroupId: 0,
    },
  },
};

export const InlineChart = withGlobalFilter(InlineChartInternal);
